import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: 'input[onlyDigits]',
})
export class OnlyDigitsDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;
    // Replace anything that is NOT a digit [0-9]
    this.el.nativeElement.value = initialValue.replace(/[^0-9]*/g, '');

    // Stop event propagation if characters were removed to avoid potential loop/flicker
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
